import { createContext } from 'react';

const context = createContext({});
context.displayName = 'Locale';
export default context;
